/**
 * Narrow a value the surrounding code has proven present (API-22). Use it
 * only next to that proof; it throws if the proof is ever wrong, rather than
 * letting `undefined` flow on silently.
 */
export function assertDefined<T>(value: T | undefined, message: string): asserts value is T {
  if (value === undefined) throw new Error(message);
}
